export const templateItems = [
  {
    group: 'Money Prizes',
    label: '$10',
    weight: 1,
    order: 0
  },
  {
    group: 'Money Prizes',
    label: '$20',
    weight: 1,
    order: 1
  },
  {
    group: 'Money Prizes',
    label: '$50',
    weight: 1,
    order: 2
  },
  {
    group: 'Money Prizes',
    label: '$100',
    weight: 1,
    order: 3
  },
  {
    group: 'Money Prizes',
    label: '$200',
    weight: 1,
    order: 4
  },
  {
    group: 'Money Prizes',
    label: '$500',
    weight: 1,
    order: 5
  },
  {
    group: 'Money Prizes',
    label: '$1,000',
    weight: 1,
    order: 6
  },
  {
    group: 'Money Prizes',
    label: 'Try Again',
    weight: 1,
    order: 7
  }
];
